<template>

  <div class="product-add" v-loading="loading">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form"  label-width="150px" v-if="!loading">
      <!--添加门店-->
      <div class="common-form">设置</div>
      <el-form-item label="是否开启物流查询：">
        <el-radio-group v-model="form.status">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="查询间隔" prop="interval" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.interval" type="number" min=10 class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="每次更新数量" prop="num" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.num" type="number" min=10 class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="限制查询时间" prop="querytime" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.querytime" type="number" min=1 class="max-w460"></el-input>
        <div>最低每隔多少小时更新一次数据</div>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>

</template>

<script>
  import ExpressApi from '@/api/express.js';
  import { formatModel } from '@/utils/base.js';
  export default {
    components:{},
    data() {
      return {
        /*是否正在加载*/
        loading: true,
        /*form表单数据
        */
        form: {
          interval: 10,//查询间隔 1  代表1秒
          status:0,//状态 0 关闭 1 开启
          num:10,//数量 每次查询的数量 即更新数量
          querytime:1,//限制查询时间 小时为单位
        },

      };
    },
    created() {
      this.getParams()
    },

    methods: {

      /*获取配置数据*/
      getParams() {
        let self = this;
        ExpressApi.getSetting({}, true)
          .then(res => {
            let vars = res.data.vars.values;
            self.form = formatModel(self.form, vars);
            self.loading=false;
          })
          .catch(error => {
            self.loading=false;
          });
      },

      /*提交*/
      onSubmit() {
        let self = this;
        let params = this.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            ExpressApi.saveSetting(params, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，设置成功',
                  type: 'success'
                });
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });
      },
      //监听复选框选中
      handleCheckedGetLog(e) {

      },
    }

  };
</script>
<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/express/index/setting.vue